'use strict';

import GQ from './GQ';

export default class Query
{
    constructor(gql, variables) {
        this._gql       = gql;
        this._variables = variables;
    }

    gql() {
        return this._gql;
    }

    variables() {
        return this._variables;
    }

    parseResponse(result) {
        return result;
    }

    async fetch(resolve, reject) {
        let self = this;
        return GQ.query({'_query_' : this}).then(function(result){ return self.parseResponse(result['_query_']); }).then(resolve, reject);
    }
}




// WEBPACK FOOTER //
// ./src/graphql/Query.js